import { render, staticRenderFns } from "./legalEntity.vue?vue&type=template&id=26881f7a"
import script from "./legalEntity.ts?vue&type=script&lang=js&external"
export * from "./legalEntity.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports